import React, { useState, useEffect, useRef } from 'react';
import TeamFeed from './TeamFeed';
import { activityService } from '../services/activityService';

const STORAGE_KEY = 'crm_feed_sidebar_open';

function getTodayTerminCount() {
  try {
    const todayStr = new Date().toISOString().slice(0, 10);
    const flat = activityService.getAllFlat();
    return flat.filter(a => {
      if (!a.ts) return false;
      if (a.ts.slice(0, 10) !== todayStr) return false;
      return (a.type === 'call' && a.outcome === 'reached_appt') || a.type === 'meeting';
    }).length;
  } catch { return 0; }
}

export default function FloatingTeamFeed({ currentUser, leads = [], onOpenLead }) {
  const [open, setOpen] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
  });
  const [unread, setUnread] = useState(0);
  const [todayCount, setTodayCount] = useState(getTodayTerminCount);
  const openRef = useRef(open);

  useEffect(() => {
    openRef.current = open;
    try { localStorage.setItem(STORAGE_KEY, open ? '1' : '0'); } catch { /* ignore */ }
    if (open) setUnread(0);
  }, [open]);

  // Track new Termin events for unread badge and today count
  useEffect(() => {
    function handler() {
      setTodayCount(getTodayTerminCount());
      if (!openRef.current) {
        setUnread(prev => prev + 1);
      }
    }
    window.addEventListener('crm-activities-changed', handler);
    return () => window.removeEventListener('crm-activities-changed', handler);
  }, []);

  return (
    <>
      {/* Slide-in panel */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: 320,
          height: '100vh',
          zIndex: 8500,
          transform: open ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.2s cubic-bezier(0.4,0,0.2,1)',
          display: 'flex',
          flexDirection: 'column',
          background: 'var(--bg2)',
          borderLeft: '1px solid var(--border)',
          boxShadow: open ? '-8px 0 40px rgba(15,23,42,0.16)' : 'none',
        }}
      >
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '14px 16px 12px',
          borderBottom: '1px solid var(--border)',
        }}>
          <span style={{ fontSize: 16 }}>🎯</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', lineHeight: 1 }}>Termine-Feed</div>
            {todayCount > 0 && (
              <div style={{ fontSize: 11, color: '#22c55e', fontWeight: 600, marginTop: 2 }}>
                {todayCount} Termin{todayCount !== 1 ? 'e' : ''} heute 🎉
              </div>
            )}
          </div>
          <button
            onClick={() => setOpen(false)}
            style={{
              width: 26, height: 26, borderRadius: 6,
              background: 'var(--bg3)', border: '1.5px solid var(--border)',
              color: 'var(--text3)', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Feed */}
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <TeamFeed
            currentUser={currentUser}
            leads={leads}
            onOpenLead={lead => { if (onOpenLead) onOpenLead(lead); setOpen(false); }}
            compact
          />
        </div>
      </div>

      {/* Toggle tab */}
      <div
        onClick={() => { setOpen(v => !v); }}
        style={{
          position: 'fixed',
          right: open ? 320 : 0,
          top: '50%',
          transform: 'translateY(-50%)',
          width: 28,
          height: todayCount > 0 ? 96 : 80,
          zIndex: 8600,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
          background: 'var(--bg2)',
          border: '1px solid var(--border)',
          borderRight: open ? '1px solid var(--border)' : 'none',
          borderRadius: '8px 0 0 8px',
          cursor: 'pointer',
          transition: 'right 0.2s cubic-bezier(0.4,0,0.2,1)',
          boxShadow: '-2px 0 12px rgba(15,23,42,0.12)',
          userSelect: 'none',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'var(--bg3)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg2)'; }}
      >
        <span style={{ fontSize: 14 }}>🎯</span>
        {todayCount > 0 && !open && (
          <span style={{
            fontSize: 10, fontWeight: 800, color: '#22c55e',
            lineHeight: 1, flexShrink: 0,
          }}>
            {todayCount}
          </span>
        )}
        {unread > 0 && !open && (
          <span style={{
            width: 14, height: 14, borderRadius: '50%',
            background: '#dc2626', color: '#fff',
            fontSize: 8, fontWeight: 700,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            lineHeight: 1, flexShrink: 0,
          }}>
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </div>
    </>
  );
}
